import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { cpvBaseAPI } from "@/api/cpv/cpv.base.api";


export interface cpvLoginResponse {
  token: string;
}


export class cpvAuthAPI extends cpvBaseAPI<any> {
  constructor() {
    super();
  }

    public login(
      cpf: string,
      secret: string
    ): AxiosObservable<cpvLoginResponse> {
      return this.axios.post(this.cpvAuthAPIUrl, {
        cpf,
        token: secret,
      },
      {
        skipGlobalErrorHandler: true,
      } as any
    );
    }

}
